import { ErrorBoundary as RollbarBoundary, Provider as RollbarProvider } from "@rollbar/react";
import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import Modal from "react-modal";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter, RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
import Rollbar from "rollbar";
import ErrorBoundary from "../Shared/ErrorBoundary";
import "../style/dashboard.scss";
import { AppRoutes } from "./AppRoutes";
import Fatal from "./shared/Fatal";
import createStore from "./store";

const MAX_FAILURES = 2;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 30,
            retry(failureCount, error) {
                return error?.response?.status === 401 || error?.response?.status === 403
                    ? false
                    : failureCount < MAX_FAILURES;
            }
        }
    },
    queryCache: new QueryCache({
        onError(error) {
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                window.location = "/account/logout";
            }
        }
    }),
});

const router = createBrowserRouter(createRoutesFromElements(AppRoutes));

const store = createStore();

const rollbarConfig = {
    accessToken: ROLLBAR_TOKEN,
    environment: ROLLBAR_ENVIRONMENT,
    enabled: ROLLBAR_TOKEN && ROLLBAR_ENVIRONMENT
};

const rollbar = rollbarConfig.enabled ? new Rollbar(rollbarConfig) : null;

// library defaults
Modal.setAppElement("#root");
Modal.defaultStyles.overlay.backgroundColor = "#666666cc";
Modal.defaultStyles.overlay.zIndex = 1000;

export default function App() {
    return rollbar ? (
        <RollbarProvider instance={rollbar} config={rollbarConfig}>
            <RollbarBoundary fallbackUI={Fatal}>
                <AppCore />
            </RollbarBoundary>
        </RollbarProvider>
    ) : (
        <ErrorBoundary>
            <AppCore />
        </ErrorBoundary>
    );
}

function AppCore() {
    return (
        <ReduxProvider store={store}>
            <QueryClientProvider client={queryClient}>
                <RouterProvider router={router } />
                <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
            </QueryClientProvider>
        </ReduxProvider>
    );
}
